import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck } from "lucide-react";
const columns = [{
  id: "platform",
  title: "Institucional"
}, {
  id: "resources",
  title: "Contactos"
}, {
  id: "social",
  title: "Siga-nos"
}];
const links = [{
  columnId: "platform",
  label: "Cuidamos da Sua Saúde com Dedicação",
  href: "/#cuidamos-da-sua-saúde"
}, {
  columnId: "platform",
  label: "Seguradoras e Acordos",
  href: "/#seguradoras-e-acordos"
}, {
  columnId: "platform",
  label: "Política de Privacidade",
  href: "/PrivacyPolicyPage"
}, {
  columnId: "platform",
  label: "Termos e Condições",
  href: "/TermsAndConditionsPage"
}, {
  columnId: "platform",
  label: "Livro de Reclamações Eletrónico",
  href: "https://www.livroreclamacoes.pt/pedido/reclamacao"
}, {
  columnId: "company",
  label: "As Nossas Especialidades",
  href: "#"
}, {
  columnId: "company",
  label: "As Nossas Especialidades",
  href: "#"
}, {
  columnId: "company",
  label: "As Nossas Especialidades",
  href: "#"
}, {
  columnId: "company",
  label: "As Nossas Especialidades",
  href: "#"
}, {
  columnId: "company",
  label: "As Nossas Especialidades",
  href: "#as-nossas-especialidades"
}, {
  columnId: "resources",
  label: "Largo de Santo António 66, 1º Andar K",
  href: "#"
}, {
  columnId: "resources",
  label: "4420-307 Gondomar",
  href: "#"
}, {
  columnId: "resources",
  label: "+351 22 483 6274 (custo p/rede fixa)",
  href: "tel:+351224836274"
}, {
  columnId: "resources",
  label: "clinicasantacruz1@gmail.com",
  href: "mailto:clinicasantacruz1@gmail.com"
}, {
  columnId: "social",
  label: "Facebook",
  href: "https://www.facebook.com/clinicasanta.cruz.9/"
}, {
  columnId: "social",
  label: "Instagram",
  href: "https://www.instagram.com/clinica.santacruz/"
}];
export default function OrbitalFooter() {
  return <section data-section-id="149723" id="rodapé-informativo" className="dark bg-primary text-primary-foreground py-16 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex justify-center mb-12">
          
        </div>

        <Separator className="mb-16 bg-primary-foreground/20" />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          {columns.map((col, i) => <div key={col.id} data-index={i} className="flex flex-col gap-4">
              <h4 className="font-semibold text-primary-foreground tracking-wide">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {links.filter(link => link.columnId === col.id).map((link, j) => <li key={`${col.id}-${j}`} data-index={j}>
                      <Link to={link.href} newTab={link.columnId === "social" || link.label === "Livro de Reclamações Eletrónico"} className="text-primary-foreground/80 text-sm transition-all duration-300 hover:text-secondary hover:drop-shadow-[0_0_8px_var(--color-secondary)]">
                        {link.label}
                      </Link>
                    </li>)}
              </ul>
            </div>)}
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-primary-foreground/20">
          <p className="text-sm text-primary-foreground/70">
            © {new Date().getFullYear()} Clínica St.ª Cruz. Todos os direitos reservados.
          </p>

          
        </div>
      </div>
    </section>;
}